export const CREATE_NEW_WORKFLOW_TAB_DEFAULT = 'createNewWorkflowTabDefault';
export const MINIMAP_MINIMIZED = 'minimap-minimized';
export const ONBOARDING_FOR_WAIT_UNTIL = 'onboarding-for-wait-until';
export const ONBOARDING_CUSTOM_FORMULA = 'onboarding-for-custom-formulaV2';
export const CANVAS_NODE_HEIGHTS = 'canvas-node-heights';
export const FLOWS_MARKED_FOR_DELETE = 'flows-marked-for-delete';
export const ZOOM_LEVEL = 'zoom-level';
export const PREVIOUSLY_TESTED_OBJECT_ID = 'previously-tested-object-id';